module.exports = __webpack_public_path__ + "static/media/Microsoft.69492a28.svg";